<template>
  <Label
    data-slot="form-label"
    :data-error="!!error"
    :class="
      cn(
        'data-[error=true]:text-danger',
        { 'opacity-disabled': disabled, 'pointer-events-none': disabled },
        props.class,
      )
    "
    :for="formItemId"
  >
    <slot />
  </Label>
</template>

<script lang="ts" setup>
import type { LabelProps } from "reka-ui";
import type { HTMLAttributes } from "vue";
import { useFormField } from "./useFormField";
import { Label } from "@/components/ui/label";
import { cn } from "@/lib/utils";

const props = defineProps<
  LabelProps & { disabled?: boolean; class?: HTMLAttributes["class"] }
>();

const { error, formItemId } = useFormField();
</script>
